export default "__VITE_ASSET__ChpUzvA0__"